import { render, staticRenderFns } from "./List-Distribution-Center.vue?vue&type=template&id=13e67e14"
import script from "./List-Distribution-Center.vue?vue&type=script&lang=js"
export * from "./List-Distribution-Center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports